import { PracticeArea } from "@design-system";
import { OrgUnitCascaderValue, orgUnitCascaderValue } from "../../utils";
import { Cascader } from "antd";
import React from "react";
import { useTaxonomyLabel, VPDLabel } from "~/context/taxonomy-context";

export type PACascaderProps = {
  paLoading: boolean;
  practiceAreas: PracticeArea[];
  selectedId?: number;
  allowClear?: boolean;
  onChange: (val: any) => any;
};
const orgUnitFromCascadeValue = (value: OrgUnitCascaderValue): number => {
  if (typeof value === "number") {
    return value;
  }

  if (!value) {
    return 0;
  }

  if (value?.[0] && value?.[1]) {
    return value[1];
  }

  if (value?.[0]) {
    return value[0];
  }

  return 0;
};

export const PracticeAreasCascader: React.FC<PACascaderProps> = ({
  practiceAreas,
  paLoading,
  onChange,
  allowClear,
  selectedId,
}) => {
  const taxonomy = useTaxonomyLabel();

  const paOptions = practiceAreas
    .filter((x) => !x.parent?.id)
    .map((pa) => {
      return {
        value: pa.id,
        label: pa.name,
        children: pa.children?.map((y) => ({ value: y.id, label: y.name })) || [],
      };
    });

  return (
    <Cascader
      style={{ marginBottom: 5, width: "100%" }}
      loading={paLoading}
      onChange={(val: any) => {
        const target = orgUnitFromCascadeValue(val);

        onChange(target);
      }}
      defaultValue={orgUnitCascaderValue(practiceAreas, selectedId)}
      placeholder={`Select ${taxonomy.PracticeArea}`}
      options={paOptions}
      showSearch={true}
      allowClear={allowClear}
    />
  );
};
